import { deploymentSetting } from '../runtime-config.js';

/**
 * Resolve the Sage API origin (CSAGE-166).
 *
 * One Sage instance serves all four Canopy environments behind distinct
 * hostnames (`sage` / `sage-dev` / `sage-uat` / `sage-demo`.gocanopy.io). The
 * API routes each request to the matching environment's user-service by the
 * Host it receives — so the SPA must call ITS OWN environment's API host: a
 * page loaded from `sage-dev.gocanopy.io` must call `api.sage-dev.gocanopy.io`,
 * not a fixed `api.sage.gocanopy.io`. Otherwise a dev/uat/demo token would be
 * sent to prod introspection and rejected.
 *
 * For the production Sage web hosts we derive `https://api.<host>` from the
 * current location. For local dev (Vite proxy / localhost), same-origin
 * deploys, or any other host we honor the configured API origin (empty →
 * relative path). In the container image that is the container's
 * SAGE_API_BASE_URL, delivered through /runtime-config.js at start
 * (runtime-config.ts, CSAGE-437); in `vite dev` it is VITE_API_BASE_URL.
 *
 * Returns an origin with no trailing slash (callers append `/reporting/api`).
 */
const SAGE_WEB_HOST = /^sage(-[a-z0-9]+)?\.gocanopy\.io$/u;

export function resolveApiOrigin(): string {
  if (typeof window !== 'undefined' && SAGE_WEB_HOST.test(window.location.hostname)) {
    // host includes the port if present; production has none (443).
    return `${window.location.protocol}//api.${window.location.host}`;
  }
  const configured = deploymentSetting('apiBaseUrl') ?? '';
  return configured.replace(/\/+$/u, '');
}
